/**
 * 门店营收监控 - AI 分析面板配置
 *
 * 定义 CompsAi 的思考模式（数据分析、预测、优化、房价建议等），
 * 当页面 API 未返回配置时作为 fallback 使用。
 */

import type { ThinkingMode } from "@ms/shared-components/comps/CompsAi";

/**
 * 创建 AI 思考模式列表
 * 供 CompsAi 展示分析入口；API 返回空时使用此默认配置
 */
export const createThinkingModes = (): ThinkingMode[] => {
  return [
    {
      id: "analyze",
      label: "数据分析",
      description: "分析营收数据和趋势",
    },
    {
      id: "predict",
      label: "预测分析",
      description: "基于历史数据预测未来趋势",
    },
    {
      id: "optimize",
      label: "优化建议",
      description: "提供营收优化建议",
    },
    {
      id: "price-suggestion",
      label: "房价建议",
      description: "基于房态、出租率、时间等因素给出房型定价建议",
    },
  ];
};

/** 分析面板按钮配置（icon 为字符串，需在使用处转为 React 组件） */
export interface AnalysisButtonConfig {
  key: string;
  iconName: string; // 图标名称，如 "DeleteOutlined"
  text: string;
  onClick: () => void;
  group?: string;
}

export const createAnalysisButtons = (handlers: {
  clearMessages: () => void;
}): AnalysisButtonConfig[] => [
  {
    key: "clear",
    iconName: "DeleteOutlined",
    text: "清理",
    onClick: handlers.clearMessages,
    group: "primary",
  },
];

/** 分析面板通用常量 */
export const ANALYSIS_PANEL_CONFIG = {
  // 分析面板标题
  ANALYSIS_TITLE: "数据分析",
} as const;
